import { Component, ViewChild, ElementRef, AfterViewInit,Input, EventEmitter ,   OnInit } from '@angular/core';
import { NcalayerService } from '../../@core/utils/ncalayer/ncalayer.service';
import { Cell, DefaultEditor, Editor } from 'ng2-smart-table';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { formatDate } from '@angular/common';
import {FormControl} from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import * as _moment from 'moment';
import {default as _rollupMoment, Moment} from 'moment';
import Swal from 'sweetalert2';


const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'DD.MM YYYY',
  },
};
@Component({
  template: `
  <div style="display:flex; align-items: center;">
  <input #name 
    [ngClass]="inputClass" matInput [matDatepicker]="picker3" fieldSize="small" placeholder="дд.мм.гггг" required   (dateChange)="addDate($event)"
    [min]="!dataStart || dataStart==undefined ? (dataBirth==undefined || !dataBirth ? sixtyYear.value : dataBirth.value ) : dataStart.value"  
    [max]="currentDay.value" 

    (input)="inputDate($event.target.value)" 
    class="form-control short-input" style="width:110px">
    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
    <mat-datepicker touchUi="true" #picker3 
    
    (dateChange)="addDate($event)"
    ></mat-datepicker>

  <div [hidden]="true" [innerHTML]="cell.getValue()" #htmlValue></div>
  </div>
  `,

  providers: [
   
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})


export class CustomEditorComponent1 extends DefaultEditor implements AfterViewInit {
  date = new FormControl( new Date());
  
  @Input() valueChange: string;  
  @ViewChild('name') name: ElementRef;
  @ViewChild('url') url: ElementRef;
  @ViewChild('htmlValue') htmlValue: ElementRef;
   Name:string;
   personsN:any []; 
   selectedPersons:never[];
   subscription:string="";
   today:any;
   datePayment:string;
   sixtyYear: any;
   dataStart: any;
   dataBirth: any;
  dataEnd: FormControl;
  currentDay: FormControl;
  Value:any;
  constructor( public ncalayer: NcalayerService,) {
    
    super();
  }
  ngOnInit() {
    this.sixtyYear=new FormControl (new Date(this.reverseDate(this.deltaDate(0,0,-16))));
    try{
 
      if (this.name.nativeElement.value !== '') {
        this.name.nativeElement.value = this.getUrlName();
       
      }
    this.name.nativeElement.value = this.getUrlName();

    this.ncalayer.getDateStart().subscribe((data: string) => {
      this.dataStart=new FormControl (new Date(this.reverseDate(data)));
      });
    this.ncalayer.getDateEnd().subscribe((data: string) => {
      this.dataEnd=new FormControl (new Date(this.reverseDate(data)));
      });
    this.ncalayer.getDateBirth().subscribe((data: string) => {
      this.dataBirth=new FormControl (new Date(this.reverseDate(data)));
      });
      this.currentDay=new FormControl (new Date());
    }
    catch(e){
      Swal.fire({
        text: 'Сервис временно не доступен',
        type: 'error',
        confirmButtonText: 'OK'
      })
    }
  }
  
  ngAfterViewInit() {
    if (this.cell.newValue !== '') {
      this.name.nativeElement.value = this.getUrlName();

    }
    // this.personsN = JSON.parse(sessionStorage.getItem("data1")).persons;
    // this.name.nativeElement.value= formatDate(this.today.value ,'dd.MM.yyyy', 'en-US');
    // this.cell.newValue = this.name.nativeElement.value
  }
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  // chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>):any {
  //   const ctrlValue = this.date.value;
  //   ctrlValue.month(normalizedMonth.month());
  //   this.date.setValue(ctrlValue);
  //   this.today=this.date;
  //   datepicker.close();
  //   console.log(formatDate(this.date.value ,'MM.yyyy', 'en-US'));
  //   this.name.nativeElement.value= formatDate(this.date.value ,'MM.yyyy', 'en-US');
  //   this.cell.newValue = this.name.nativeElement.value
  // }
  getUrlName(): string {
    return this.htmlValue.nativeElement.innerText;
  }
  addDate(event:MatDatepickerInputEvent<Date>){
    this.cell.newValue =formatDate(event.target.value, 'dd.MM.yyyy','en-US');
    this.name.nativeElement.value= formatDate(this.today.value ,'dd.MM.yyyy', 'en-US');
    this.ncalayer.setDateEnd(formatDate(event.target.value, 'dd.MM.yyyy','en-US'));
  }
  inputDate(event:any){
   
    // this.reverseDate(this.deltaDate(0,0,-16));
    this.ncalayer.setDateEnd(formatDate(event.target.value, 'dd.MM.yyyy','en-US'));
  }
  checkBithLimit(d1:Date){
    let d2 = new Date();
    return d2.getFullYear()-d1.getFullYear(); 
  }
  reverseDate(date:string){
    return date.split(".").reverse().join("-");  
  }
  deltaDate(days:number, months:number, years:number) {
    var date = new Date();
    let isToday = (date.valueOf() === (new Date()).valueOf() ? 'true' : 'false');
    date.setDate(date.getDate() + days);
    date.setMonth(date.getMonth() + months);
    date.setFullYear(date.getFullYear()+ years);
    return  ((date.getMonth() + (isToday == 'true' ? 1 : 0) == 2) && this.pad1(date.getDate(), 2) == '29' ? '28' : this.pad1(date.getDate(), 2)) + '.' + this.pad1(date.getMonth() + (isToday == 'true' ? 1 : 0), 2) + '.' +  (date.getFullYear());
  }
  pad1(num:any, size:any) {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }
  private pad(n): string {
   if (n < 10) {
      return '0' + n;
  }
    return n.toString();
  }
}

